<template>
    <div class="l-constrained l-constrained-narrow l-content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <h1>Deliver Test Lead</h1>
                </div>
            </div>

            <status-message v-model="statusMessage"></status-message>

            <div class="row">
                <div class="col-sm-12">
                    <form class="form" @submit.prevent="submit">
                        <div class="form-group">
                            <label>Direct/Multi-Carrier</label>
                            <select class="form-control" v-model="form.direct_mc">
                                <option v-for="(label, key) in directMcOptions" :key="key" :value="key">{{ label }}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Job</label>
                            <select class="form-control" v-model="form.job" @change="onJobChange">
                                <optgroup v-for="group in jobOptions" :key="group.label" :label="group.label">
                                    <option v-for="opt in group.options" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
                                </optgroup>
                            </select>
                            <p v-if="loadingTestData" class="help-block"><i class="fa fa-pulse fa-spinner"></i> Loading job data ...</p>
                        </div>

                        <div class="form-group">
                            <label>Action type</label>
                            <select class="form-control" v-model="form.action">
                                <option value="deliver">Just deliver test lead to customer</option>
                                <option value="email">Just send me delivery email</option>
                                <option value="all">Deliver test lead to customer &amp; send me delivery email</option>
                            </select>
                        </div>

                        <h3>Driver</h3>

                        <div class="form-group">
                            <label>Name</label>
                            <input type="text" class="form-control" v-model="form.name">
                        </div>

                        <div class="form-group">
                            <label>Email</label>
                            <input type="text" class="form-control" v-model="form.email">
                        </div>

                        <div class="form-group">
                            <label>Phone Number</label>
                            <input type="text" class="form-control" v-model="form.phone">
                        </div>

                        <div class="form-group">
                            <label>Zip Code</label>
                            <input type="text" class="form-control" v-model="form.zip_code">
                        </div>

                        <div class="form-group">
                            <label>CDL Class A Experience</label>
                            <select class="form-control" v-model="form.cdl_xp">
                                <option v-for="(label, value) in cdlXpOptions" :key="value" :value="value">{{ label }}</option>
                            </select>
                        </div>

                        <div v-if="customQuestions.length > 0">
                            <h3>Custom Questions</h3>
                            <p v-if="loadingQuestions" class="help-block"><i class="fa fa-pulse fa-spinner"></i> Loading custom questions ...</p>

                            <div v-for="q in customQuestions" :key="q.key" class="form-group">
                                <label>{{ q.text }}</label>

                                <select v-if="q.type === 'dropdown'" class="form-control" v-model="form.custom_questions[q.key]">
                                    <option v-for="opt in q.options" :key="opt" :value="opt">{{ opt }}</option>
                                </select>

                                <div v-else-if="q.type === 'checkboxes'">
                                    <div v-for="opt in q.options" :key="opt" class="checkbox">
                                        <label>
                                            <input type="checkbox" :value="opt" v-model="form.custom_questions[q.key]"> {{ opt }}
                                        </label>
                                    </div>
                                </div>

                                <input v-else type="text" class="form-control" v-model="form.custom_questions[q.key]">
                            </div>
                        </div>

                        <button type="submit" class="btn btn-danger">
                            <span class="glyphicon glyphicon-send" aria-hidden="true"></span> Deliver
                        </button>
                    </form>
                </div>
            </div>
        </div>

        <employer-notes-wrapper :employer-id="employerId" />
        <busy-spinner :is-on="isBusy"></busy-spinner>
    </div>
</template>

<script>
export default {
    name: 'send-test-app',
    props: {
        employerId: { type: Number, required: true },
        directMcOptions: { type: Object, required: true },
        jobOptions: { type: Array, required: true },
        cdlXpOptions: { type: Object, required: true },
        defaultJobId: { type: Number, default: null },
    },
    data() {
        return {
            form: {
                direct_mc: 'direct',
                job: this.defaultJobId,
                action: 'deliver',
                name: 'Test Lead',
                email: 'test@truckersreport.com',
                phone: '555-123-4567',
                zip_code: '12345',
                cdl_xp: 60,
                custom_questions: {},
            },
            customQuestions: [],
            loadingQuestions: false,
            loadingTestData: false,
        };
    },
    mounted() {
        if (this.form.job) {
            this.loadJobData(this.form.job);
            this.loadCustomQuestions(this.form.job);
        }
    },
    methods: {
        onJobChange() {
            if (this.form.job) {
                this.loadJobData(this.form.job);
                this.loadCustomQuestions(this.form.job);
            } else {
                this.form.zip_code = '12345';
                this.form.cdl_xp = 60;
                this.customQuestions = [];
                this.form.custom_questions = {};
            }
        },
        loadJobData(jobId) {
            this.loadingTestData = true;
            this.makeGet(
                this.url('admin/employer/' + this.employerId + '/get-test-data-by-job/' + jobId),
                {},
                (data) => {
                    if (data.cdl_xp !== undefined) this.form.cdl_xp = data.cdl_xp;
                    if (data.zip_code !== undefined) this.form.zip_code = data.zip_code;
                    this.loadingTestData = false;
                },
                () => {
                    this.loadingTestData = false;
                },
                false
            );
        },
        loadCustomQuestions(jobId) {
            this.loadingQuestions = true;
            this.makeGet(
                this.url('admin/employer/' + this.employerId + '/get-custom-questions-by-job/' + jobId),
                {},
                (data) => {
                    this.customQuestions = data.questions;
                    this.setDefaultAnswers();
                    this.loadingQuestions = false;
                },
                () => {
                    this.customQuestions = [];
                    this.form.custom_questions = {};
                    this.loadingQuestions = false;
                },
                false
            );
        },
        setDefaultAnswers() {
            var answers = {};
            this.customQuestions.forEach(function (q) {
                if (q.type === 'dropdown' && q.options && q.options.length) {
                    answers[q.key] = q.options[0];
                } else if (q.type === 'checkboxes' && q.options && q.options.length) {
                    answers[q.key] = [q.options[0]];
                } else {
                    answers[q.key] = 'Test answer';
                }
            });
            this.$set(this.form, 'custom_questions', answers);
        },
        submit() {
            this.makePost(
                this.url('admin/employer/' + this.employerId + '/send-test-app'),
                this.form,
                (data) => {
                    if (data.redirect) {
                        window.location.href = data.redirect;
                    }
                },
                () => {
                    this.showError('Failed to send test lead. Please try again.');
                }
            );
        },
    },
};
</script>
